

































































import DocumentLink from '@/components/DocumentLink'
import timeline from '@/directives/timeline.coffee'

export default {
    name: 'SlideshowItem',

    components:
        DocumentLink : DocumentLink

    directives:
        timeline: timeline

    data: -> fields: @defaultFields()

    computed:
        isDark: -> @$parent.isDark
        useBlend: -> @$parent.useBlend
        isVideo: -> @fields.video_link.url?
        isImage: -> @fields.image.url? and not @isVideo
        buttonClass: ->
            'uk-button-default': @isDark
            'uk-button-secondary': !@isDark

    methods:
        defaultFields: ->
            image: [],
            video_link: [],
            title: [],
            subtitle: [],
            button_title: [],
            button_link: []

        setContent: (document) ->
            fields =
                image: document.image
                video_link: document.video_link
                title: document.title
                subtitle: document.subtitle
                button_title: document.button_title
                button_link: document.button_link
            $.extend @fields, fields

    created: ->
        @setContent @$attrs.document
}
